import { Alert, Box, Stack, Text } from '@mantine/core';
import { IconAlertCircle } from '@tabler/icons-react';
import { getWidgetPropsComponent } from '../../../getWidgetPropsComponent';
import { WidgetType } from '../../../types';
import { SectionProps } from '../../types';
import classes from './WidgetProps.module.css';
import SeriesColorPicker from './SeriesColorPicker';
import { useTranslation } from 'react-i18next';

type WidgetPropsProps = SectionProps & {
  widgetType: WidgetType;
  device: 'web' | 'mobile';
};

export default function WidgetPropsSection({ widgetType, updateConfig, config, validationErrors, setValidationErrors, device }: WidgetPropsProps ) {
  const { t } = useTranslation( 'widgets' );
  const WidgetPropsComponent = getWidgetPropsComponent( widgetType, device );

  // Check if there are validation errors for this section
  const sectionErrors = validationErrors?.widgetProps;
  
  return (
    <div className={classes.container}>
      <Stack gap="md">
        {/* The `<h4>Widget Properties` heading and its standing blue "configure
            specific properties…" banner are gone (2026-08-17), for the same reason
            the Basic section's were: the accordion header above already reads
            "Propiedades del widget", and a permanent notice describing what a
            section is FOR costs a line of a 420px panel every time it is open. */}
        
        {sectionErrors && Object.keys( sectionErrors ).length > 0 && (
          <Alert icon={<IconAlertCircle size="1.2rem" />} color="red" variant="light" mb="xs">
            <Text size='sm' c="red.9">
              {t( 'widget_builder_widget_props_errors_message','Please fix the following errors:' )}
              <ul style={{ marginTop: '8px', marginBottom: '0' }}>
                {Object.entries( sectionErrors ).map(([ field, error ]) => (
                  <li key={field}>{error}</li>
                ))}
              </ul>
            </Text>
          </Alert>
        )}
        
        {/* Series colours — chart types only. See `SeriesColorPicker` for why it is
            a POSITIONAL, PARTIAL list rather than one colour per series. */}
        <SeriesColorPicker widgetType={widgetType} config={config} updateConfig={updateConfig} />

        <Box className={classes.content}>
          <WidgetPropsComponent config={config} updateConfig={updateConfig} />
        </Box>
      </Stack>
    </div>
  );
}
